<div class="gcontainer bwhite">
  <div class="row">
    <div class="col-md-7">
      <nav aria-label="breadcrumb" class="mt-8">
        <ol class="breadcrumb">
          <li
            class="breadcrumb-item active breadcrumb cursor"
            aria-current="page"
            (click)="reDirectUrl()"
            (keypress)="reDirectUrl()"
            tabindex="0">
            Dashboard
          </li>
          @if (worksheetRecords) {
            <li class="breadcrumb-item active" aria-current="page">
              {{ worksheetRecords.company.name }} -  {{ worksheetRecords.project.projectName }} - Worksheet -
              @if (soilType === 'precast') {
                <span>Pre Cast</span>
              }
              @if (soilType === 'nativesoil') {
                <span>Native Soil</span>
              }
            </li>
          }
        </ol>
      </nav>
    </div>

    <!-- Action Buttons -->
    <div class="col-auto ms-auto">
      <div class="action-bar">

        @if (soilType === 'nativesoil') {
          <button
            mat-raised-button
            (click)="printTargetWeights()">
            Print Target Weights
          </button>
        }

        <button
          mat-raised-button
          class="refresh"
          (click)="refresh()">
          Refresh
        </button>

        <button
          mat-raised-button
          class="print-btn"
          (click)="export()"
          matTooltip="Print">
          <mat-icon>print</mat-icon>
          <span class="print-text">PRINT</span>
        </button>

        @if (roleCheck(['Manager','Admin','Reportwriter']) || soilType === 'precast') {
          <button
            mat-raised-button
            color="primary"
            [matMenuTriggerFor]="aboveMenu"
            >
            ACTIONS
          </button>
        }

        <!-- Menu -->
        <mat-menu #aboveMenu="matMenu" yPosition="below">
          @if (roleCheck(['Manager','Admin','Reportwriter'])) {
            <button
              mat-menu-item
              (click)="review(projectId, soilType)"
              >
              <img src="/assets/icons/File.svg" width="16" class="mr-8" />
              View Submission Form
            </button>
          }

          @if (roleCheck(['Manager','Admin']) && soilType === 'nativesoil' && hasAsReceivedMC) {
            <button
              mat-menu-item
              (click)="notifyCustomerConfirmation()"
              >
              <img src="/assets/icons/File.svg" width="16" class="mr-8" />
              Notify Customer
            </button>
          }

          @if (soilType === 'precast' && isTestingInProgeress()) {
            <button
              mat-menu-item
              (click)="completeWorksheet()">
              <img src="/assets/icons/checked.svg" width="16" class="mr-8" />
              Complete Worksheet
            </button>
          }

          @if (roleCheck(['Manager','Admin'])) {
            <button
              mat-menu-item
              (click)="downloadTRWorksheet()"
              >
              <img src="/assets/icons/File.svg" width="16" class="mr-8" />
              Download TR Worksheet
            </button>
          }

          @if (roleCheck(['Manager','Admin']) && soilType === 'precast') {
            <button
              mat-menu-item
              (click)="downloadWorksheetReport()"
              >
              <img src="/assets/icons/File.svg" width="16" class="mr-8" />
              Download Report
            </button>
          }
        </mat-menu>

      </div>
    </div>

    @if (setRefresh) {
      <div class="col-md-12 mt-16">
        <mat-card class="bsmokewhite">
          <mat-card-content>
            <div class="row">
              <div class="col-md-11">
                <div class="row">
                  <div class="col-md-1 worksheet-header-column-1">
                    <h1 class="mat-h1">
                      @if (soilType === 'precast') {
                        <span>Pre Cast</span>
                      }
                      @if (soilType === 'nativesoil') {
                        <span>Native Soil</span>
                      }
                    </h1>
                  </div>
                  <div class="col-md-1  worksheet-header-column-2">
                    <div class="pr-32">
                      @if (worksheetRecords) {
                        <span
                          class="mat-header-data"
                          >
                          {{ worksheetRecords.project.referenceId }}
                        </span>
                      }
                    </div>
                    <mat-label class="mat-header-subtitle-2">Reference</mat-label>
                  </div>
                  <div class="col-md-8  worksheet-header-column-3">
                    <div class="pr-32">
                      @if (worksheetRecords) {
                        <span
                          class="mat-header-data"
                          >
                          {{ worksheetRecords.project.projectName }}
                        </span>
                      }
                    </div>
                    <mat-label class="mat-header-subtitle-2">Project Name</mat-label>
                  </div>
                  <div class="col-md-2">
                    @if (isGeoTesting) {
                      <mat-chip class="chipset-green float-right">
                        <img
                          src="./../../../assets/icons/pre-approval-tick.svg"
                          class="icon-position"
                          alt="Rush-Testing-Warning" />
                          <span class="text-white chip-text">Geotherm Field Testing</span>
                        </mat-chip>
                      }
                      @if (soilType === 'precast' && preApprovalTesting) {
                        <mat-chip class="chipset-blue float-right">
                          <img
                            src="./../../../assets/icons/pre-approval-tick.svg"
                            class="icon-position"
                            alt="Rush-Testing-Warning" />
                            <span class="text-white chip-text"> Pre-Approval</span>
                          </mat-chip>
                        }
                        @if (isRushTesting) {
                          <mat-chip class="chipset-warning float-right">
                            <img
                              src="./../../../assets/icons/rush-warning-icon.svg"
                              class="icon-position"
                              alt="Rush-Testing-Warning" />
                              <span class="chip-text"> Rush</span>
                            </mat-chip>
                          }
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-3">
                          <mat-label class="mat-subtitle-2">Customer</mat-label>
                          <div class="pr-32">
                            @if (worksheetRecords) {
                              <span
                                class="mat-subtitle-1 truncate-label-2line"
                                #tooltip="matTooltip"
                                [matTooltip]="worksheetRecords.company.name">
                                {{ worksheetRecords.company.name }}
                              </span>
                            }
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div>
                            <mat-label class="mat-subtitle-2">Project Number</mat-label>
                            <div class="pr-32">
                              @if (worksheetRecords) {
                                <span
                                  class="mat-subtitle-1 truncate-label-2line"
                                  #tooltip="matTooltip"
                                  [matTooltip]="worksheetRecords.project.projectNumber">
                                  {{ worksheetRecords.project.projectNumber }}
                                </span>
                              }
                            </div>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div>
                            <mat-label class="mat-subtitle-2">Samples Received</mat-label>
                            <div>
                              @if (sampleReceivedDate) {
                                <span class="mat-subtitle-1 truncate-label">
                                  {{ sampleReceivedDate | utcToLocal: 'date' }}
                                </span>
                              }
                            </div>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div>
                            <mat-label class="mat-subtitle-2">Instructions Confirmed</mat-label>
                            <div>
                              @if (instructionConfirmedAt) {
                                <span class="mat-subtitle-1 truncate-label">
                                  {{ instructionConfirmedAt | utcToLocal: 'date' }}
                                </span>
                              }
                            </div>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <mat-label class="mat-subtitle-2">Storage Location</mat-label>
                          <div class="pr-32">
                            @if (worksheetRecords) {
                              <span
                                class="mat-subtitle-1 truncate-label-2line"
                                #tooltip="matTooltip"
                                [matTooltip]="worksheetRecords.project.storageCompartment ?? ''">
                                {{ worksheetRecords.project.storageCompartment }}
                              </span>
                            }
                          </div>
                        </div>
                        <div class="col-md-1">
                          <div>
                            <mat-label class="mat-subtitle-2">Due Date</mat-label>
                            <div>
                              @if (dueDate) {
                                <span class="mat-subtitle-1 truncate-label">
                                  {{ dueDate | utcToLocal: 'date' }}
                                </span>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-1">
                      @if (daysleft === null) {
                        <div class="no-of-days na-days-left">NA</div>
                      }
                      @if (daysleft && daysleft > 0) {
                        <div class="no-of-days">{{ daysleft }} days</div>
                      }
                      @if (daysleft === 0 || daysleft && daysleft < 1) {
                        <div class="no-of-days critical-days-left">0 days</div>
                      }
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          }
          @if (setRefresh) {
            <div class="col-md-5 mt-16" >
              <div class="notes-wrapper">
                @if (note) {
                  <div>
                    <mat-label class="mat-subtitle-2 bold-title">
                      @if (note.updatedBy) {
                        <span class="d-inline"
                          >{{ note.updatedBy.firstName }} {{ note.updatedBy.lastName }}:</span
                          >
                      }
                      @if (note.createdAt) {
                        <span class="d-inline">
                          {{ note.createdAt | utcToLocal: 'date' }} {{ note.createdAt | utcToLocal: 'time' }}
                        </span>
                      }
                    </mat-label>
                    <div>
                      <span
                        class="mat-subtitle-2"
                        matTooltipClass="my-custom-tooltip"
                        #tooltip="matTooltip"
                        [matTooltip]="note.text">
                        {{ noteText }}
                      </span>
                    </div>
                  </div>
                }
                @if (!note) {
                  <div style="min-height: 60px">
                    <p class="truncate-label">No Notes Available.</p>
                  </div>
                }
              </div>
              <div>
                <a class="view-all" (click)="openViewNotesDialog()" href="javascript:void(0);">
                  <img alt="View Notes" src="../../../../assets/icons/New Window.svg"/>
                  View All Notes
                </a>
                <a class="view-all" (click)="openViewInstructionsDialog()" href="javascript:void(0);">
                  <img alt="View Notes" src="../../../../assets/icons/New Window.svg"/>
                  View Instructions
                </a>
                <app-customer-attachments
                  class="worksheet-attachements"
                  [projectId]="projectId"
                  [backgroundClass]="'gray'"
                  [showSuccess]="false"
                style="vertical-align: middle; margin-right: 16px"></app-customer-attachments>
              </div>
            </div>
          }
          @if (setRefresh) {
            <div class="col-md-7 mt-16" >
              <div class="row">
                <div class="col-md-4 pr-12">
                  <mat-card class="project-details-card">
                    <span class="project-test-data-title"
                      >Oven Date
                      @if (!isReportWriter) {
                        <a
                          class="float-right"
                          (click)="openProjectDetailsComponent('Oven Date', 'ovenDate')"
                          href="javascript:void(0)">
                          <img alt="info Icon" class="star-mar-top" src="../../../../assets/icons/Edit.svg" />
                        </a>
                      }
                    </span>
                    <span class="mat-subtitle-1 line-clamp text-word-break" [innerHTML]=" lineBreak(ovenDate)" #tooltip="matTooltip" matTooltip="{{ ovenDate }}">
                    </span>
                  </mat-card>
                </div>
                <div class="col-md-4 pr-12">
                  <mat-card class="project-details-card">
                    <span class="project-test-data-title">
                      Wet Test Data
                      <img
                        alt="info Icon"
                        class="star-mar-top"
                        #tooltip="matTooltip"
                        matTooltip='Separate values by a "," comma'
                        src="../../../../assets/icons/Alert-grey.svg" />
                        @if (!isReportWriter) {
                          <a
                            class="float-right"
                            (click)="openProjectDetailsComponent('Wet Test Data', 'wetTestData')"
                            href="javascript:void(0)">
                            <img alt="info Icon" class="star-mar-top" src="../../../../assets/icons/Edit.svg" />
                          </a>
                        }
                      </span>
                      <span
                        class="mat-subtitle-1 line-clamp text-word-break"[innerHTML]=" lineBreak(wetTestData)"
                        #tooltip="matTooltip"
                        matTooltip="{{ wetTestData }}">
                      </span>
                    </mat-card>
                  </div>
                  <div class="col-md-4 pr-12">
                    <mat-card class="project-details-card">
                      <span class="project-test-data-title"
                        >Dry Test Data
                        <img
                          alt="info Icon"
                          class="star-mar-top"
                          #tooltip="matTooltip"
                          matTooltip='Separate values by a "," comma'
                          src="../../../../assets/icons/Alert-grey.svg" />
                          @if (!isReportWriter) {
                            <a
                              class="float-right"
                              (click)="openProjectDetailsComponent('Dry Test Data', 'dryTestData')"
                              href="javascript:void(0)">
                              <img alt="info Icon" class="star-mar-top" src="../../../../assets/icons/Edit.svg" />
                            </a>
                          }
                        </span>
                        <span
                          class="mat-subtitle-1 line-clamp text-word-break"[innerHTML]=" lineBreak(dryTestData)"
                          #tooltip="matTooltip"
                          matTooltip="{{ dryTestData }}">
                        </span>
                      </mat-card>
                    </div>
                  </div>
                </div>
              }
              @if (setRefresh) {
                <div class="col-md-12 mt-16" >
                  @if (soilType === 'precast' && projectStatuses) {
                    <app-precast-table
                      #precastTable
                      (assigned)="assignedDone()"
                      [projectId]="projectId"
                      (allResPrecastWorksheet)="handleAllResPrecastWorksheet($event)"
                      (headerPrecastWorksheet)="handleFetchPrecastHeader($event)"
                      (rowDeletionSuccess)="onRowDeletionSuccess()"
                      [projectStatuses] = "projectStatuses"
                      [projectStatusId] = "projectStatusId"
                      [worksheetRecords]="worksheetRecords"
                    ></app-precast-table>
                  }
                  @if (soilType === 'nativesoil' && projectStatuses) {
                    <app-nativesoil-table
                      #nativeSoilTable
                      (assigned)="assignedDone()"
                      [projectId]="projectId"
                      [instructionConfirmed] = "instructionsConfirmed"
                      (fetchAllHeader)="handleFetchAllHeader($event)"
                      (rowDeletionSuccess)="onRowDeletionSuccess()"
                      (allResNativeWorksheet)="handleAllResNativeWorksheet($event)"
                      [projectStatuses] = "projectStatuses"
                      [projectStatusId] = "projectStatusId"
                      [worksheetRecords]="worksheetRecords"
                    ></app-nativesoil-table>
                  }
                </div>
              }
            </div>
          </div>
